import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DeviceHeader from '../../../components/header/DeviceHeader';

import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Container,
} from '@mui/material';
import { useOutletContext } from 'react-router-dom';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';

import { makeStyles } from 'tss-react/mui';
import * as timeago from 'timeago.js';

import {
  collection,
  doc,
  query,
  orderBy,
  limit as limitFn,
  onSnapshot
} from 'firebase/firestore';
import { db } from '../../../store/api/fbConfig';

const useStyles = makeStyles()(() => ({
  root: {
    marginTop: '20px',
    marginBottom: '60px',
    padding: '0 20px',
  },
  logIcon: {
    verticalAlign: 'middle',
    marginRight: '10px',
  },
  LoadMoreBox: {
    textAlign: 'center',
    marginTop: '20px',
  },
  LoadMoreButton: {
    padding: '10px 20px',
  },
}));

const getIcon = (level = '') => {
  const l = level.toLowerCase();
  if (l === 'error') return <ErrorIcon color="error" />;
  if (l === 'success') return <CheckCircleIcon color="success" />;
  return <InfoIcon color="primary" />;
};

const LogPage = () => {
  const { id } = useParams();
  const { classes } = useStyles();
  const [limit, setLimit] = useState(10);
  const [expanded, setExpanded] = useState(false);
  const [DeviceLogs, setDeviceLogs] = useState([]);
  const { userRole } = useOutletContext();

  useEffect(() => {
    const logColRef = collection(doc(collection(db, 'Devices'), id), 'Log');
    const logQuery = query(logColRef, orderBy('dateCreated', 'desc'), limitFn(limit));

    const unsubscribe = onSnapshot(logQuery, (snapshot) => {
      const logs = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setDeviceLogs(logs);
    });

    return () => unsubscribe();
  }, [id, limit]);

  const handleLoadMore = () => {
    setLimit(prev => prev + 10);
  };

  const handleChange = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : false);
  };

  return (
    <div className={classes.root}>
      <Container>
        {DeviceLogs.map((log) => {
          const time = log.dateCreated ? new Date(log.dateCreated.seconds * 1000) : null;
          const formattedTime = time
            ? `${timeago.format(time)} — ${time.toLocaleString('en-AU')}`
            : 'Unknown time';

          return (
            <Accordion
              key={log.id}
              expanded={expanded === log.id}
              onChange={handleChange(log.id)}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  {getIcon(log.level)} {formattedTime}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  {log.message && (
                    <>
                      <Typography variant="subtitle2">Message</Typography>
                      <Typography>{log.message}</Typography>
                    </>
                  )}
                  {log.details && (
                    <>
                      <Typography variant="subtitle2" sx={{ mt: 1 }}>Details</Typography>
                      <Typography component="pre" sx={{ whiteSpace: 'pre-wrap' }}>
                        {typeof log.details === 'string'
                          ? log.details
                          : JSON.stringify(log.details, null, 2)}
                      </Typography>
                    </>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          );
        })}

        <Box className={classes.LoadMoreBox}>
          <Button onClick={handleLoadMore} className={classes.LoadMoreButton}>
            Load More
          </Button>
        </Box>
      </Container>
    </div>
  );
};

export default LogPage;
